<template>
  <div class="chess-loader-desktop">
    <skeleton-loader width="140px" class="mb-2" />
    <div class="chess-loader-desktop__table">
      <div class="chess-loader-desktop__fixed">
        <div class="chess-loader-desktop__head">
          <skeleton-loader height="16px" />
          <skeleton-loader height="16px" />
        </div>
        <div v-for="item in 3" :key="item" class="chess-loader-desktop__cell">
          <skeleton-loader height="44px" />
        </div>
      </div>
      <div v-for="item in 20" :key="item" class="chess-loader-desktop__col">
        <div class="chess-loader-desktop__head">
          <div class="chess-loader-desktop__cell">
            <skeleton-loader height="36px" />
          </div>
        </div>
        <div v-for="item in 3" :key="item" class="chess-loader-desktop__cell">
          <skeleton-loader height="44px" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import SkeletonLoader from '@/core/components/interface/SkeletonLoader.vue';
</script>

<style scoped lang="scss">
.chess-loader-desktop {
  $root: &;

  display: grid;

  grid-template-columns: minmax(0, 1fr);

  &__table {
    display: flex;

    overflow: hidden;
  }

  &__fixed {
    flex: 212px 0 0;

    #{$root}__head {
      gap: 2px;

      padding: 0 18px 0 10px;
    }

    #{$root}__cell {
      margin-right: 8px;
    }
  }

  &__col {
    flex: 84px 0 0;
  }

  &__head {
    display: flex;
    flex-direction: column;
    justify-content: center;

    height: 54px;

    border-bottom: 1px solid $border-color-light;
  }

  &__cell {
    padding: 2px;
  }
}
</style>
